<template>
  <Modal :identifier="modalIdentifier" :title="textChooseVendor" is-full-mobile>
    <div class="flex-grow-1 mb-n3 mx-n3 p-3 bg-gray-100">
      <button
        v-for="(vendor, index) in vendors"
        :key="index"
        @click="chooseVendor(vendor)"
        class="btn btn-reset btn-block shadow-sm shadow-hover vendor-button"
      >
        <div class="h6 mb-1 text-left">{{ vendor }}</div>
        <div class="px-1 border rounded text-xs delivery-option text-muted">
          {{ textDeliveryService }}
        </div>
      </button>
      <button @click="resetVendor" class="btn btn-primary-link btn-block">
        {{ textReset }}
      </button>
    </div>
  </Modal>
</template>

<script>
import Modal from "./Modal";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "VendorFilterModal",
  components: {
    Modal,
  },
  props: {
    textChooseVendor: {
      type: String,
      required: true,
    },
    textReset: {
      type: String,
      required: true,
    },
    textDeliveryService: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modalIdentifier: "essentialsVendorSelector",
    };
  },
  computed: {
    ...mapGetters({
      vendors: "lists/getFilterableVendors",
    }),
  },
  methods: {
    ...mapActions({
      setVendorFilter: "lists/setVendorFilter",
      hideModal: "hideModal",
    }),
    chooseVendor(value) {
      this.setVendorFilter(value);
      this.hideModal(this.modalIdentifier);
    },
    resetVendor() {
      this.setVendorFilter("");
      this.hideModal(this.modalIdentifier);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.vendor-button {
  position: relative;
  background: $white;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.delivery-option {
  text-transform: uppercase;
}
</style>
